import { ValidatorFn } from '@angular/forms';

/** `Validators.required` for text that the server trims: spaces alone count as missing. */
export const requiredText: ValidatorFn = control => (String(control.value ?? '').trim() ? null : { required: true });
